import { render, staticRenderFns } from "./cardIndicatorHead.vue?vue&type=template&id=0c83b920"
import script from "./cardIndicatorHead.vue?vue&type=script&lang=js"
export * from "./cardIndicatorHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports